import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { AuthorityEndpoints } from '../../config/authority/authoritys-end-point';
//import { AuthorityEndpoints } from '../../config/authoritys/authoritys-end-point';
import { ISiteMasterVM } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class AuthoritysService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }
  

  getAuthority<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(AuthorityEndpoints.GetAuthority, reqModel);
   } 

//  getSiteById<T>(id: number): Observable<HttpResponse<T>> {
//   return this.genericApiService.get<T>(`${SiteEndpoints.GetSiteById}/${id}`);
// }

  addUpdateAuthority<T>(model: any): Observable<HttpResponse<T>> {
   return this.genericApiService.post(AuthorityEndpoints.SaveAuthority, model);
  }
 
  deleteAuthority<T>(AuthorityId: number): Observable<HttpResponse<T>> {
   return this.genericApiService.delete(`${AuthorityEndpoints.DeleteAuthority}/${AuthorityId}`);
  }

}
